import script from "./PcVersion.vue?vue&type=script&setup=true&lang=ts"
export * from "./PcVersion.vue?vue&type=script&setup=true&lang=ts"

import "./PcVersion.vue?vue&type=style&index=0&id=1be0a5fd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be0a5fd"]])

export default __exports__